import axios from 'axios';
import { useEffect, useState } from 'react';
import Skelet from '../Skelet';
import ContactsOfficesItem from './ContactsOfficesItem';
import styles from '../../styles/modules/contacts/ContactsOffices.module.scss';

const ContactsOffices = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(process.env.NEXT_PUBLIC_API + '/offices');

        if (!response.data || response.data.status !== 'ok') throw new Error(response.data.text);

        setData([
          ...response.data.data,
          {
            city: 'Служба контроля качества',
            offices: [
              {
                address: 'ул Варфоломеева, д 227',
                area: 'Центр',
                phone: '+7 961 427-37-53'
              }
            ]
          }
        ]);
        setIsError(false);
        setIsLoading(false);
      } catch (error) {
        setIsError(true);
      }
    };
    fetchData();
  }, []);

  if (isLoading || isError)
    return (
      <section className="block">
        <div className="fixed">
          <h3>
            <Skelet width={220} height={51} />
          </h3>
          <div className={styles.offices}>
            {[...Array(8).keys()].map((value) => (
              <div className={styles.item} key={value}>
                <h5 className={[styles.title, 'clear'].join(' ')}>
                  <Skelet width={90} height={33} />
                </h5>
                <div className={styles.address}>
                  <Skelet width={130} height={21} style={{ marginTop: 4 }} />
                </div>
                <div className={styles.group}>
                  <div className={styles.subtext}>
                    <Skelet width={100} height={21} style={{ marginTop: 15 }} />
                  </div>
                  <div className={styles.text} style={{ marginTop: 4 }}>
                    <Skelet width={200} />
                    <Skelet width={200} style={{ marginTop: 4 }} />
                  </div>
                </div>
                <div className={styles.group} style={{ marginTop: 60 }}>
                  <Skelet width={80} />
                  <div>
                    <Skelet width={120} style={{ marginTop: 4 }} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );

  return (
    <>
      {data.map((value, index) => (
        <section className="block" key={index}>
          <div className="fixed">
            <h3 className={styles.title}>{value.city}</h3>
            <div className={styles.offices}>
              {value.offices.map((val, i) => (
                <ContactsOfficesItem office={val} key={i} />
              ))}
            </div>
          </div>
        </section>
      ))}
    </>
  );
};

export default ContactsOffices;
